import type {
  AvatarIconPosition,
  AvatarSize,
  AvatarIconSize,
} from "@faire/slate/private/avatar/types";

export { Avatar } from "./Avatar";

export namespace Avatar {
  export type IconPosition = AvatarIconPosition;
  export type Size = AvatarSize;
  export type IconSize = AvatarIconSize;
}
